import { useReducer } from "react"
import { useParams } from "react-router-dom"

import { multipleDateRangeReducer } from "helpers/reducers/dateRangeReducer"
import AlertsContext from "widgets/alerts/AlertsContext"
import AlertsTabView from "widgets/alerts/AlertsTabView"
import ActivityPanel from "widgets/alerts/ActivityPanel"
import NewAlertSettingButton from "widgets/alerts/settings/NewAlertSettingButton"
import DeviceAlertsContent from "widgets/device/DeviceAlertsContent"
import { BodyContainer } from "widgets/styled/containers"

function DeviceAlerts() {
  const { id } = useParams()
  const [multipleDateRange, dispatchMultipleDateRange] = useReducer(
    multipleDateRangeReducer,
    {},
  )

  return (
    <AlertsContext.Provider
      value={{
        multipleDateRange,
        dispatchMultipleDateRange,
      }}
    >
      <BodyContainer disableGutters maxWidth="xl">
        <AlertsTabView
          tabsConfig={{
            configuredAlerts: <DeviceAlertsContent />,
            activity: <ActivityPanel devicesIds={[Number(id)]} />,
          }}
          actions={{
            configuredAlerts: (
              <NewAlertSettingButton entity="device" entityId={Number(id)} />
            ),
          }}
        />
      </BodyContainer>
    </AlertsContext.Provider>
  )
}

export default DeviceAlerts
